export const ContentComponentWithDnDCompat = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line
require('./latest/ContentComponentWithDnDLatest').ContentComponentWithDnDLatest :
// eslint-disable-next-line
require('./legacy/ContentComponentWithDnDLegacy').ContentComponentWithDnDLegacy;